import { create } from "zustand";
import { AvatarStyle, randInt } from "flavr-common";
import { hexToNum, COLOR_FLAVIA_BLUE, randomPredefinedColor } from "../style/predefined-colors";
import { AccessoireGroup, AvatarAccessoires } from "../../modules/avatar/AvatarAccessoires";
import { usersService } from "../../modules/multiplayer/UsersService";
import { preferencesService } from "../../modules/preferences/PreferencesService";
export const useAvatarConfigStore = create((set) => ({
    avatar: {
        baseColor: hexToNum(COLOR_FLAVIA_BLUE),
        style: AvatarStyle.Monitor,
        avatarHat: undefined,
        avatarShoulder: undefined
    },
    setBaseColor: (color) => {
        set((state) => ({ avatar: Object.assign(Object.assign({}, state.avatar), { baseColor: color }) }));
    },
    setStyle: (style) => {
        set((state) => ({ avatar: Object.assign(Object.assign({}, state.avatar), { style }) }));
    },
    setHat: (avatarHat) => {
        set((state) => ({ avatar: Object.assign(Object.assign({}, state.avatar), { avatarHat }) }));
    },
    setShoulder: (avatarShoulder) => {
        set((state) => ({ avatar: Object.assign(Object.assign({}, state.avatar), { avatarShoulder }) }));
    }
}));
export function initializeAvatarConfigStore() {
    var _a, _b, _c, _d, _e;
    let storedAvatar = null;
    try {
        storedAvatar = JSON.parse((_a = localStorage.getItem("avatar")) !== null && _a !== void 0 ? _a : "null");
    }
    catch (e) {
        console.error("error parsing stored avatar", e);
    }
    const store = useAvatarConfigStore.getState();
    if (storedAvatar) {
        store.setBaseColor(storedAvatar.baseColor);
        store.setHat((_c = (_b = storedAvatar.accessoires) === null || _b === void 0 ? void 0 : _b.find((a) => { var _a; return ((_a = AvatarAccessoires.getAccessoireDef(a.id)) === null || _a === void 0 ? void 0 : _a.group) === AccessoireGroup.Hat; })) !== null && _c !== void 0 ? _c : undefined);
        store.setShoulder((_e = (_d = storedAvatar.accessoires) === null || _d === void 0 ? void 0 : _d.find((a) => { var _a; return ((_a = AvatarAccessoires.getAccessoireDef(a.id)) === null || _a === void 0 ? void 0 : _a.group) === AccessoireGroup.Shoulder; })) !== null && _e !== void 0 ? _e : undefined);
    }
    else {
        store.setBaseColor(hexToNum(randomPredefinedColor()));
        store.setHat(createRandomAccesoire(AccessoireGroup.Hat));
        store.setShoulder(createRandomAccesoire(AccessoireGroup.Shoulder));
    }
    if (preferencesService.getBooleanPreferredValue("showAvatarVRStyle", false)) {
        store.setStyle(AvatarStyle.Head);
    }
    else {
        store.setStyle(AvatarStyle.Monitor);
    }
    useAvatarConfigStore.subscribe(storeAvatarConfig);
}
export function toUserAvatar(avatarDef) {
    return {
        baseColor: avatarDef.baseColor,
        imageUrl: "img/avatars/defaultUserImageNew.png",
        style: avatarDef.style,
        accessoires: [avatarDef.avatarHat, avatarDef.avatarShoulder].filter((a) => a !== undefined)
    };
}
function storeAvatarConfig(state) {
    const avatar = {
        baseColor: state.avatar.baseColor,
        imageUrl: "",
        style: state.avatar.style, // TODO: Remove this from UserAvatar
        accessoires: [state.avatar.avatarHat, state.avatar.avatarShoulder].filter((a) => a !== undefined)
    };
    localStorage.setItem("avatar", JSON.stringify(avatar));
    preferencesService.updatePreferences([{ key: "showAvatarVRStyle", value: state.avatar.style === AvatarStyle.Head }]);
    usersService.setGuestUserInfo(usersService.getGuestInfo().username, avatar);
}
function createRandomAccesoire(group) {
    const accessoires = [...AvatarAccessoires.iconsByGroupIterator(group)];
    const index = randInt(0, accessoires.length);
    if (index === accessoires.length)
        return undefined;
    return { id: accessoires[index][0], color: hexToNum(randomPredefinedColor()) };
}
